/**
 * 특정 urlScheme으로 이동
 *
 * @param url - 이동할 urlScheme
 */
export const moveToLink = urlScheme => {
  const tempElement = document.createElement('a');
  tempElement.href = urlScheme;
  tempElement.click();
  tempElement.remove();
};
